import { Alert } from '@creditornot/cb-alert';
import React from 'react';

import { usePluralization } from 'common/hooks';

type ListingManagerNoteProps = {
  numOfVenuesConnectedToOfferingPlatform: number;
};

export const ListingManagerNote = ({ numOfVenuesConnectedToOfferingPlatform }: ListingManagerNoteProps) => {
  const { formatPluralMessage } = usePluralization();

  return (
    <Alert
      variant="warning"
      title={formatPluralMessage({
        id: 'menu.menu-sync.listing-manager-info',
        count: numOfVenuesConnectedToOfferingPlatform,
      })}
      style={{ margin: '16px' }}
    />
  );
};
